<script setup lang="ts">
import { useComponentClasses } from "../../composables";
import ModalCloseButton from "./ModalCloseButton.vue";

interface ModalHeaderProps {
  /** Adds a close button and padding to clear the button */
  closeable?: boolean;
}

const { closeable = false } = defineProps<ModalHeaderProps>();

const { element, root } = useComponentClasses("ui-modal-header");

const rootClass = root({
  modifiers: {
    closeable,
  },
});

const emit = defineEmits<{
  /** Emitted when the close button is clicked */
  (event: "close"): void;
}>();
</script>

<template>
  <div :class="rootClass">
    <slot />
    <ModalCloseButton v-if="closeable" :class="element('close')" @click="emit('close')" />
  </div>
</template>

<style scoped>
.ui-modal-header {
  padding: var(--_padding-y) var(--_padding-x);
  position: relative;
}

.ui-modal-header--closeable {
  /* Add 2rem to the right padding to account for the close button (24px / 16px = 1.5rem) */
  padding-right: calc(calc(var(--_padding-x) * 2) + 1.5rem);
}

.ui-modal-header__close {
  position: absolute;
  right: var(--_padding-x);
  top: var(--_padding-y);
}
</style>
